import styled from "styled-components";
import { Thirds } from "@conserveit/blocks";

interface Props {
  sidebarOpen: boolean;
}

export const Container = styled.div<Props>`
  overflow: hidden;
  position: relative;
  min-height: calc(100vh - 330px);
  width: ${(props) => (props.sidebarOpen ? "100%" : "calc(100% + 400px)")};
  /* NOTE: This is temporarily disabled because we're now removing columns when
  opening/closing the sidebar and this makes it look jarring. */
  /* transition: width 0.3s ease-in-out; */
  display: flex;
  flex-direction: column;
`;

export const Content = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  width: calc(100% - 400px);
  justify-content: space-between;
`;

export const StyledThirds = styled(Thirds)`
  width: 100%;
`;
